import React from 'react'
import './about.css'
import AboutBanner from '../../Components/About/AboutBanner'
import WhyWeChoose from '../../Components/About/WhyWeChoose'
import MeetOurExpectTeam from '../../Components/About/MeetOurExpectTeam'
import WhatOurClientsSay from '../../Components/About/WhatOurClientsSay'
import IsoCeritfication from '../../Components/About/IsoCeritfication'
import HomeServices from '../../Components/Home/HomeServices'
const AboutPage = () => {
  return (
    <div>
      <AboutBanner/>
      <WhyWeChoose/>
      < IsoCeritfication/>
      <MeetOurExpectTeam/>
      <WhatOurClientsSay/>
      <HomeServices/>
    </div>
  )
}

export default AboutPage
